import camelCase from 'lodash/camelCase';
import { useSelector } from 'react-redux';

import { ImageName, SVG_IMAGES } from '../../../../../../shared/components/svg-image/images';
import { LoggableError } from '../../../../../../shared/helpers/errors';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { createLogger } from '../../../../../../shared/helpers/loggerFacade';
import { useActions } from '../../../../../../shared/hooks';
import { ReactionType } from '../../../../../../types';
import { selectSelfReactionType } from '../../../../selectors';
import { setReactionAction } from '../../../reaction';
import { useToolbarButtonClickHandlerMaker } from '../../hooks';

const logger = createLogger('reactions');

export function useReactionProps(reactionType: ReactionType) {
    const selfReactionType = useSelector(selectSelfReactionType);
    const isThisMyReaction = selfReactionType === reactionType;
    const reactionPostfix = isThisMyReaction ? 'down' : 'up';
    const key = `${reactionType}-${reactionPostfix}`;
    const title = i18n('toolbar', key);
    const testId = `${key}-button`;

    const iconName = camelCase(key) as ImageName;

    if (!SVG_IMAGES[iconName]) {
        logger.error(
            new LoggableError('iconName is missing in SVG_IMAGES', {
                method: 'useReactionProps',
                additional: { iconName },
            })
        );
    }

    const actions = useActions({ setReactionAction });
    const makeOnClick = useToolbarButtonClickHandlerMaker();
    const onClick = makeOnClick(
        () => actions.setReactionAction({ reactionType: isThisMyReaction ? null : reactionType }),
        'hand_and_reactions',
        `${reactionType}_${isThisMyReaction ? 'down' : 'up'}`
    );

    return { onClick, title, iconName, testId };
}
